import { Injectable, inject } from '@angular/core';
import { DevicesRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs';
import { DeviceScheduledTasksStoreActions } from './index';

@Injectable({ providedIn: 'root' })
export class DeviceScheduledTasksResolver {
  private readonly store = inject(Store);

  resolve() {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (!udid) {
          return;
        }

        this.store.dispatch(
          DeviceScheduledTasksStoreActions.DeviceScheduledTasksResolverActions.scheduledTasksRequested({ udid })
        );
      }),
      map(() => true),
      first()
    );
  }
}
